import { SVGProps } from 'react';
const SvgDragVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM8 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM14 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM8 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM14 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM8 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
    />
  </svg>
);
export default SvgDragVertical;
